if (!customElements.get('product-form')) {
  function getVariantByIdFromForm(form, variantId) {
    if (!form || variantId == null || variantId === '') return null;
    const scriptEl = form.querySelector('script[data-product-variants]');
    if (!scriptEl || !scriptEl.textContent) return null;
    try {
      const variants = JSON.parse(scriptEl.textContent);
      if (!Array.isArray(variants)) return null;
      return variants.find((v) => String(v.id) === String(variantId)) || null;
    } catch (e) {
      return null;
    }
  }

  function getListCardSubmitLabel(variant, form) {
    if (!variant || !form || typeof window.variantStrings === 'undefined') {
      return typeof window.variantStrings !== 'undefined' ? window.variantStrings.addToCart : 'Add to cart';
    }
    const subId = form.getAttribute('data-subscription-variant-id');
    if (subId && String(variant.id) === String(subId)) {
      return window.variantStrings.addToBox;
    }
    const idxStr = form.getAttribute('data-roast-type-option-index');
    if (idxStr && window.variantStrings.reserveNextBatch) {
      const n = parseInt(idxStr, 10);
      if (n >= 1 && n <= 3) {
        const rv = variant['option' + n];
        if (rv != null && String(rv) === 'Reserve Next Batch') {
          return window.variantStrings.reserveNextBatch;
        }
      }
    }
    return window.variantStrings.addToCart;
  }

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cartNotification = document.querySelector('cart-notification');
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        
        // 添加空值检查，避免在缺货时（没有提交按钮）报错
        if (this.submitButton) {
          this.submitButtonText = this.submitButton.querySelector('span');
          if (document.querySelector('cart-drawer')) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }
        } else {
          this.submitButtonText = null;
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.submitInProgress = false;

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.optionChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, this.handleListVariantOptionChange.bind(this));
        }
      }

      disconnectedCallback() {
        if (this.optionChangeUnsubscriber) {
          this.optionChangeUnsubscriber();
          this.optionChangeUnsubscriber = null;
        }
      }

      handleListVariantOptionChange({ data: { event } }) {
        if (!this.form || !this.contains(event.target)) return;
        const variantSelects = this.form.querySelector('variant-selects');
        if (!variantSelects) return;
        const variantsScript = this.form.querySelector('[data-product-variants]');
        if (!variantsScript || !variantsScript.textContent) return;

        let variants;
        try {
          variants = JSON.parse(variantsScript.textContent);
        } catch (e) {
          return;
        }
        if (!Array.isArray(variants) || variants.length === 0) return;

        const optionInputs = variantSelects.querySelectorAll('.product-form__input');
        const selectedValues = [];
        optionInputs.forEach((wrapper) => {
          const select = wrapper.querySelector('select');
          if (select) {
            selectedValues.push(select.value);
          } else {
            const checked = wrapper.querySelector('input:checked');
            selectedValues.push(checked ? checked.value : null);
          }
        });

        const variant = variants.find((v) => {
          const o1 = (v.option1 || '').toString();
          const o2 = (v.option2 || '').toString();
          const o3 = (v.option3 || '').toString();
          return (
            (selectedValues[0] == null || o1 === selectedValues[0]) &&
            (selectedValues[1] == null || o2 === selectedValues[1]) &&
            (selectedValues[2] == null || o3 === selectedValues[2])
          );
        });

        const idInput = this.form.querySelector('[name=id]');
        if (idInput && variant) {
          idInput.value = variant.id;
          idInput.disabled = false;
        }
        // Keep selling_plan in sync with selected variant to avoid 422 (e.g. "Cannot apply selling plan to variant")
        const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
        if (sellingPlanInput && variant) {
          if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
            const firstAlloc = variant.selling_plan_allocations[0];
            const planId =
              firstAlloc && firstAlloc.selling_plan && firstAlloc.selling_plan.id != null
                ? firstAlloc.selling_plan.id
                : '';
            sellingPlanInput.value = planId !== '' ? planId : '';
          } else {
            sellingPlanInput.value = '';
          }
        }
        if (this.submitButton) {
          if (variant && !variant.available) {
            this.submitButton.disabled = true;
            const soldOutSpan = this.submitButton.querySelector('.sold-out-message');
            const textSpan = this.submitButton.querySelector('span:first-child');
            if (textSpan) textSpan.classList.add('hidden');
            if (soldOutSpan) soldOutSpan.classList.remove('hidden');
          } else {
            this.submitButton.disabled = false;
            const soldOutSpan = this.submitButton.querySelector('.sold-out-message');
            const textSpan = this.submitButton.querySelector('span:first-child');
            if (textSpan) textSpan.classList.remove('hidden');
            if (soldOutSpan) soldOutSpan.classList.add('hidden');
            // Card list / quick-add: Add to box vs Reserve Next Batch vs Add to cart
            const subscriptionVariantId = this.form.getAttribute('data-subscription-variant-id');
            const roastIdx = this.form.getAttribute('data-roast-type-option-index');
            if (variant && textSpan && typeof window.variantStrings !== 'undefined') {
              if (subscriptionVariantId || roastIdx) {
                textSpan.textContent = getListCardSubmitLabel(variant, this.form);
              }
            }
          }
        }

        if (variant) {
          const shippingTimesScript = variantSelects.querySelector('[data-variant-shipping-times]');
          const shippingTimeDisplay = this.form.querySelector('[data-shipping-time-display]');
          if (shippingTimesScript && shippingTimeDisplay) {
            try {
              const shippingTimes = JSON.parse(shippingTimesScript.textContent);
              const entry = Array.isArray(shippingTimes)
                ? shippingTimes.find((e) => e.id === variant.id)
                : null;
              const text = entry?.shipping_time ?? '';
              shippingTimeDisplay.textContent = typeof text === 'string' ? text : '';
            } catch (e) {}
          }
        }

      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.submitInProgress) return;

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        if (!variantId || !/^\d+$/.test(String(variantId).trim())) {
          this.handleErrorMessage('Please select a variant');
          return;
        }
        const quantity = formData.get('quantity');
        if (quantity != null && quantity !== '') {
          const q = parseInt(quantity, 10);
          if (isNaN(q) || q < 1) {
            this.handleErrorMessage('Please enter a valid quantity');
            return;
          }
        }

        this.handleErrorMessage();
        this.submitInProgress = true;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // Check if this is a silent add (for recommendation products)
        let isSilentAdd = this.dataset.silentAdd === 'true';
        
        // On mobile, always open cart drawer instead of silent add
        const isMobile = window.innerWidth <= 749;
        if (isMobile) {
          isSilentAdd = false;
        }
        
        // Handle add-on products (bundle and exclusive gifts)
        this.addSelectedAddOnProducts(formData);
        
        // Always include sections for cart-icon-bubble updates, but only set active element for non-silent adds
        if (this.cart) {
          // Get sections from the primary cart (notification or drawer)
          const sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
          
          // If cart-notification exists, also include cart-drawer's sections
          if (this.cartDrawer && this.cart !== this.cartDrawer) {
            const drawerSections = this.cartDrawer.getSectionsToRender().map((section) => section.id);
            // Merge sections, avoiding duplicates
            drawerSections.forEach(sectionId => {
              if (!sectionsToRender.includes(sectionId)) {
                sectionsToRender.push(sectionId);
              }
            });
          }

          // Box subscription collection: refresh right-rail panel from same response as cart (avoids stale GET + extra round trip)
          const subscriptionPanel = document.querySelector('subscription-box-panel');
          const boxGridSectionId = subscriptionPanel?.dataset?.sectionId;
          if (boxGridSectionId && !sectionsToRender.includes(boxGridSectionId)) {
            sectionsToRender.push(boxGridSectionId);
          }
          
          formData.append('sections', sectionsToRender);
          formData.append('sections_url', window.location.pathname);
          if (!isSilentAdd) {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              return response.text().then((text) => {
                let parsed = {};
                try {
                  parsed = JSON.parse(text);
                } catch (e) {}
                const msg = parsed.description || parsed.message || response.statusText || `HTTP ${response.status}`;
                this.handleErrorMessage(parsed.description || parsed.message || msg);
                throw new Error(`HTTP error! status: ${response.status} – ${msg}`);
              });
            }
            return response.json();
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if (!this.submitButton || !this.submitButtonText) {
                this.error = true;
                return;
              }
              
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (!isSilentAdd) {
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                        
                        // Also update cart drawer if it exists (update without opening)
                        if (this.cartDrawer && this.cart !== this.cartDrawer && typeof this.cartDrawer.updateContents === 'function') {
                          this.cartDrawer.updateContents(response);
                        }
                      });
                    } else {
                      // For silent add, update sections without showing notification
                      CartPerformance.measure("add:paint-updated-sections", () => {
                        // Update cart notification sections
                        this.cart.getSectionsToRender().forEach((section) => {
                          // Use selector if available, otherwise fall back to id
                          const element = section.selector
                            ? document.querySelector(section.selector)
                            : document.getElementById(section.id);
                          if (element && response.sections && response.sections[section.id]) {
                            try {
                              const sectionHTML = this.cart.getSectionInnerHTML(
                                response.sections[section.id],
                                section.selector
                              );
                              if (sectionHTML) {
                                element.innerHTML = sectionHTML;
                              }
                            } catch (error) {
                              console.warn('Failed to update section:', section.id, error);
                            }
                          }
                        });
                        
                        // Also update cart drawer if it exists (update without opening)
                        if (this.cartDrawer && typeof this.cartDrawer.updateContents === 'function') {
                          this.cartDrawer.updateContents(response);
                        }
                      });
                    }
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              const inlineModal = this.closest('inline-modal-dialog');
              if (inlineModal && typeof inlineModal.hide === 'function') {
                inlineModal.hide();
              }
              if (!isSilentAdd) {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  if (this.cartDrawer && inlineModal) {
                    this.cartDrawer.updateContents(response);
                    const trigger = this.submitButton || document.querySelector('#cart-icon-bubble');
                    this.cartDrawer.open(trigger);
                  } else {
                    this.cart.renderContents(response);
                    if (this.cartDrawer && this.cart !== this.cartDrawer && typeof this.cartDrawer.updateContents === 'function') {
                      this.cartDrawer.updateContents(response);
                    }
                  }
                });
              } else {
                // For silent add, update sections without showing notification
                CartPerformance.measure("add:paint-updated-sections", () => {
                  // Update cart notification sections
                  this.cart.getSectionsToRender().forEach((section) => {
                    // Use selector if available, otherwise fall back to id
                    const element = section.selector
                      ? document.querySelector(section.selector)
                      : document.getElementById(section.id);
                    if (element && response.sections && response.sections[section.id]) {
                      try {
                        const sectionHTML = this.cart.getSectionInnerHTML(
                          response.sections[section.id],
                          section.selector
                        );
                        if (sectionHTML) {
                          element.innerHTML = sectionHTML;
                        }
                      } catch (error) {
                        console.warn('Failed to update section:', section.id, error);
                      }
                    }
                  });
                  
                  // Also update cart drawer if it exists (update without opening)
                  if (this.cartDrawer && typeof this.cartDrawer.updateContents === 'function') {
                    this.cartDrawer.updateContents(response);
                  }
                });
              }
            }
          })
          .catch((e) => {
            console.error('Product form submission error:', e);
            this.error = true;
            this.handleErrorMessage(e.message || 'Failed to add product to cart. Please try again.');
            
            // Publish error event
            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: e.message || 'Unknown error',
                message: 'Failed to add product to cart',
              });
            }
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              if (!this.error) {
                this.submitButton.removeAttribute('aria-disabled');
                
                // For silent add, show a brief success state
                if (isSilentAdd) {
                  const buttonText = this.submitButton.querySelector('.button-text');
                  const buttonSuccess = this.submitButton.querySelector('.button-success');
                  
                  if (buttonText && buttonSuccess) {
                    // Hide loading spinner first
                    const loadingSpinner = this.querySelector('.loading__spinner');
                    if (loadingSpinner) loadingSpinner.classList.add('hidden');
                    
                    // Show success state
                    buttonText.classList.add('hidden');
                    buttonSuccess.classList.remove('hidden');
                    this.submitButton.classList.add('button--success');
                    
                    setTimeout(() => {
                      buttonText.classList.remove('hidden');
                      buttonSuccess.classList.add('hidden');
                      this.submitButton.classList.remove('button--success');
                    }, 2000);
                  }
                }
              }
            }
            
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            
            // Always hide loading spinner when done (for both success and error cases)
            const loadingSpinner = this.querySelector('.loading__spinner');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');

            this.submitInProgress = false;
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) return;
        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (typeof window.variantStrings !== 'undefined') {
            const subscriptionVariantId = this.form.getAttribute('data-subscription-variant-id');
            const roastIdx = this.form.getAttribute('data-roast-type-option-index');
            const variantId = this.variantIdInput?.value;
            if ((subscriptionVariantId || roastIdx) && variantId) {
              const variant = getVariantByIdFromForm(this.form, variantId);
              if (variant) {
                this.submitButtonText.textContent = getListCardSubmitLabel(variant, this.form);
              } else if (subscriptionVariantId && String(variantId) === String(subscriptionVariantId)) {
                this.submitButtonText.textContent = window.variantStrings.addToBox;
              } else {
                this.submitButtonText.textContent = window.variantStrings.addToCart;
              }
            } else if (subscriptionVariantId && variantId && String(variantId) === String(subscriptionVariantId)) {
              this.submitButtonText.textContent = window.variantStrings.addToBox;
            } else {
              this.submitButtonText.textContent = window.variantStrings.addToCart;
            }
          } else {
            this.submitButtonText.textContent = 'Add to cart';
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      addSelectedAddOnProducts(formData) {
        // Get the current section ID from the form
        const sectionId = this.closest('[data-section]')?.dataset.section;
        if (!sectionId) return;

        // Handle bundle products
        const bundleProductsContainer = document.getElementById(`bundle_products-${sectionId}`);
        
        if (bundleProductsContainer) {
          const selectedBundleItems = bundleProductsContainer.querySelectorAll('.product-list_item.selected');
          
          selectedBundleItems.forEach((item, index) => {
            const productId = item.dataset.productId;
            const variantId = item.dataset.variantId;
            
            if (productId && variantId) {
              formData.append(`items[${index + 1}][id]`, variantId);
              formData.append(`items[${index + 1}][quantity]`, 1);
            }
          });
        }

        // Handle exclusive gifts (with line item properties so Shopify Script applies the discount)
        const exclusiveGiftsContainer = document.getElementById(`exclusive_gifts-${sectionId}`);
        
        if (exclusiveGiftsContainer) {
          const selectedGiftItems = exclusiveGiftsContainer.querySelectorAll('.product-list_item.selected');
          
          if (selectedGiftItems.length > 0) {
            const productInfo = this.closest('product-info');
            const handle = productInfo?.dataset?.productHandle || (productInfo?.dataset?.url?.split('/').filter(Boolean).pop() || '');
            const propertyKey = handle === 'xbloom-original'
              ? '__bundle_machine_with_free_original'
              : handle === 'xbloom-studio'
                ? '__bundle_machine_with_free_studio'
                : '__bundle_machine_with_free';
            const mainVariantId = this.variantIdInput?.value || this.form?.querySelector('[name="id"]')?.value || '';
            const bundleIdStr = `exclusive_gifts_${sectionId}_${mainVariantId}`;

            // 从服务端渲染的白名单属性中读取允许的赠品 handle 列表
            const allowedHandles = (exclusiveGiftsContainer.dataset.allowedGiftHandles || '')
              .split(',')
              .map(h => h.trim())
              .filter(Boolean);

            formData.append('properties[__bundle_machine_main]', bundleIdStr);

            selectedGiftItems.forEach((item, index) => {
              const productId = item.dataset.productId;
              const variantId = item.dataset.variantId;
              const productHandle = item.dataset.productHandle;

              // 安全校验：只允许白名单内的产品作为赠品
              if (allowedHandles.length > 0 && !allowedHandles.includes(productHandle)) return;

              if (productId && variantId) {
                const giftIndex = (bundleProductsContainer?.querySelectorAll('.product-list_item.selected').length || 0) + index + 1;
                formData.append(`items[${giftIndex}][id]`, variantId);
                formData.append(`items[${giftIndex}][quantity]`, 1);
                formData.append(`items[${giftIndex}][properties][${propertyKey}]`, bundleIdStr);
                formData.append(`items[${giftIndex}][properties][__gift]`, 'exclusive_gift');
              }
            });
          }
        }
      }
    }
  );
}